import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDestTransformationInactive = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 18,
	viewBox: "0 0 18 18",
	width: 18,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 9,
		cy: 9,
		fill: "#f2f2f2",
		r: 7.5,
		stroke: "#808080",
		strokeWidth: 3
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 9,
		cy: 9,
		fill: "#808080",
		r: 3
	})]
});
export { SvgDestTransformationInactive as ReactComponent };
